import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge class names, last conflicting utility wins.
 *
 * The usual shadcn helper. Without the merge step a component's own `p-2` and a
 * caller's `p-4` both land in the class list and the winner is whichever Tailwind
 * emitted last — which is stylesheet order, not intent.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Where song jackets and character art come from.
 *
 * Not this server: the art ships with the game and redistributing it is not ours to
 * do. An operator points this at their own mirror; unset, the portal renders its
 * placeholder and every page still works.
 */
export const assetsHost: string = import.meta.env.VITE_ASSETS_HOST ?? '';

export const enableImages: boolean = assetsHost !== '';
